<template>
  <v-container v-if="filters && queues">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Filters</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog width="800" v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" small fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title
                >{{ editMode ? "Edit" : "Add" }} Filter</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Name"
                    v-model="dialogData.name"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-switch v-model="dialogData.adds_skip">
                    <template v-slot:label> Adds Skip </template></v-switch
                  >
                </v-col>
                <v-col>
                  <v-select
                    :items="queuesArray"
                    multiple
                    v-model="dialogData.target_queue"
                    label="Target Queue"
                    item-text="name"
                    item-value="id"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3>Includes</h3>
                  <v-row
                    v-for="(item, index) in dialogData.filter_data.contains"
                    :key="index"
                  >
                    <v-col>
                      <v-text-field
                        v-model="dialogData.filter_data.contains[index].feild"
                        label="Key"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="dialogData.filter_data.contains[index].value"
                        label="Value"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-btn
                        @click="
                          dialogData.filter_data.contains.splice(index, 1)
                        "
                        color="red"
                        fab
                        small
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="d-flex">
                      <v-btn
                        @click="
                          dialogData.filter_data.contains.push({
                            feild: '',
                            value: '',
                          })
                        "
                        color="primary"
                        fab
                        small
                        ><v-icon>mdi-plus</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <h3>Excludes</h3>
                  <v-row
                    v-for="(item, index) in dialogData.filter_data.not_contains"
                    :key="index"
                  >
                    <v-col>
                      <v-text-field
                        v-model="
                          dialogData.filter_data.not_contains[index].feild
                        "
                        label="Key"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="
                          dialogData.filter_data.not_contains[index].value
                        "
                        label="Value"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-btn
                        @click="
                          dialogData.filter_data.not_contains.splice(index, 1)
                        "
                        color="red"
                        fab
                        small
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="d-flex">
                      <v-btn
                        @click="
                          dialogData.filter_data.not_contains.push({
                            feild: '',
                            value: '',
                          })
                        "
                        color="primary"
                        fab
                        small
                        ><v-icon>mdi-plus</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="cancel()"
                v-if="editMode"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :disabled="!dialogData.name"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          v-if="filters"
          :headers="headers"
          :items="filters"
          :sort-by="['id']"
          :items-per-page="-1"
        >
          <template v-slot:[`item.adds_skip`]="{ item }">
            <v-chip v-if="item.adds_skip" color="green" dark
              ><v-icon>mdi-check</v-icon></v-chip
            >
            <v-chip v-else color="red" dark>
              <v-icon>mdi-close</v-icon>
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="deleteFilter(item)">
              mdi-delete
            </v-icon>
            <v-icon small @click="editFilter(item)"> mdi-pencil </v-icon>
          </template>
          <template v-slot:[`item.target_queue`]="{ item }">
            <v-chip-group
              v-if="item.target_queue.length !== 0 && item.target_queue[0]"
            >
              <v-chip
                v-for="(queue, index) in item.target_queue"
                :key="queue"
                color="primary"
                dark
                v-show="index < 3"
              >
                {{ queues.get(queue).name | queue }}
              </v-chip>

              <v-chip
                v-if="item.target_queue.length > 3"
                color="secondary"
                dark
              >
                +{{ item.target_queue.length - 3 }}
              </v-chip>
            </v-chip-group>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      <v-icon>{{ snackbarIcon }}</v-icon> {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  data() {
    return {
      dialog: false,
      user: {},
      filters: [],
      queues: [],
      queuesArray: [],
      dialogData: {
        action: "create",
        filter_data: {
          contains: [{ feild: "tags", value: "us_only" }],
          not_contains: [],
        },
        target_queue: null,
        name: "",
        adds_skip: true,
      },
      editMode: false,
      snackbar: false,
      snackbarColor: "",
      snackbarIcon: "",
      snackbarText: "",
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Adds Skip",
          value: "adds_skip",
          sortable: false,
        },
        {
          text: "Queues",
          value: "target_queue",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
    };
  },
  methods: {
    getData() {
      axios
        .get("/api/v1/filters/")
        .then((res) => {
          this.filters = res.data;
        })
        .catch((err) => {
          this.error = err.response.data;
          console.log(err);
        });
      axios.get("/api/v1/queues/list").then((res) => {
        this.queuesArray = res.data;
        // Turn the array into a map
        this.queues = new Map(res.data.map((q) => [q.id, q]));
      });
    },
    deleteFilter(filter) {
      axios
        .delete("/api/v1/filters/", { data: { id: filter.id } })
        .then(() => {
          this.getData();
          this.snackbar = true;
          this.snackbarColor = "success";
          this.snackbarIcon = "mdi-check";
          this.snackbarText = "Filter Deleted";
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-alert";
          this.snackbarText = err.response.data;
        });
    },
    save() {
      if (this.editMode) {
        this.dialogData.action = "update";
      } else {
        this.dialogData.action = "create";
      }
      axios
        .post("/api/v1/filters/", this.dialogData)
        .then((res) => {
          console.log(res.data);
          this.dialog = false;
          this.editMode = false;
          this.getData();
          this.snackbar = true;
          this.snackbarColor = "success";
          this.snackbarIcon = "mdi-check";
          this.snackbarText = "Filter Saved";
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-alert";
          this.snackbarText = err.response.data;
        });
      this.dialog = false;
      this.dialogData = {
        filter_data: {
          contains: [{ feild: "tags", value: "us_only" }],
          not_contains: [],
        },
        target_queue: null,
        name: "",
        adds_skip: true,
      };
    },
    editFilter(filter) {
      this.editMode = true;
      console.log(filter);
      this.dialogData = filter;
      this.dialog = true;
    },
    cancel() {
      this.editMode = false;
      this.dialog = false;
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.user = JSON.parse(localStorage.user);
  },
};
</script>

<style lang="scss" scoped></style>
